import InactiveStores from "../components/InactiveStores";

export default function InactiveStoresPage() {
  return <InactiveStores />;
}
